/* GreenTheory — Trova la tua palestra.
   Si carica negli asset del tema e si richiama con tre righe:

     <div id="gt-locator"></div>
     <script src="{{ 'gt-locator.js' | asset_url }}" defer></script>

   Dove Liquid non viene eseguito (elemento HTML di PageFly) va bene anche
   l'indirizzo diretto del file su cdn.shopify.com.

   Generato da build/blocco.py — le modifiche a mano si perdono alla prossima build. */
(function(){
'use strict';
const CSS = `:is(#gt-locator,.gt-locator){
  /* Altezza decisa qui, non dal contenuto. Legarla al contenuto voleva dire che
     una pillola in più su una riga faceva saltare tutto il blocco a ogni filtro.
     È legata allo schermo perché un numero fisso che sta bene su un monitor
     diventa una colonna infinita su un portatile.
     Per farla seguire il riquadro che ospita il locator: --gt-h:100%. */
  --gt-h:min(760px, 82vh);
  /* Su telefono la mappa ha un'altezza sua invece di una sola percentuale: in
     percentuale pura, sugli schermi piccoli si mangiava tutto l'elenco. Il tetto
     in pixel la tiene a bada, la percentuale la fa crescere sui telefoni alti. */
  --gt-h-map:min(380px, 42vh);
  /* Angoli smussati: dentro un riquadro con i bordi tondi, gli spigoli vivi del
     locator sbordavano. \`overflow:hidden\` fa il resto, tagliando mappa ed elenco
     sulla stessa curva. Si cambia da fuori con --gt-raggio. */
  --gt-raggio:14px;
  display:flex; flex-direction:column; width:100%;
  height:var(--gt-h); overflow:hidden; border-radius:var(--gt-raggio);
}
/* Su telefono il blocco è un po' più alto: la colonna è una sola e deve contenere
   mappa ed elenco uno sotto l'altro. */
@media (max-width:860px){ :is(#gt-locator,.gt-locator){ --gt-h:min(880px, 92vh); } }
:is(#gt-locator,.gt-locator) .app{ flex:1 1 auto; min-height:0; height:auto; }
:is(#gt-locator,.gt-locator){
    --bg:#060606; --panel:#0C0C0C; --elev:#151515;
    --ink:#FFFFFF; --muted:rgba(255,255,255,.55); --faint:rgba(255,255,255,.35);
    --line:rgba(255,255,255,.10); --line-str:rgba(255,255,255,.18);
    --hover:rgba(255,255,255,.06);
    --accent:#00FF00; --accent-dim:rgba(0,255,0,.13); --accent-line:rgba(0,255,0,.45);
    --red:#FF4D4D;
    --r-lg:20px; --r-md:14px;
    --shadow:0 10px 34px rgba(0,0,0,.6);
    --panel-w:412px;
  }:is(#gt-locator,.gt-locator) *{box-sizing:border-box}:is(#gt-locator,.gt-locator){
    margin:0; background:var(--bg); color:var(--ink);
    font:15px/1.5 Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;
    -webkit-font-smoothing:antialiased;
  }:is(#gt-locator,.gt-locator) h2, :is(#gt-locator,.gt-locator) h3, :is(#gt-locator,.gt-locator) .brand b{font-family:"Inter Tight",Inter,system-ui,sans-serif}:is(#gt-locator,.gt-locator) button, :is(#gt-locator,.gt-locator) select{font:inherit; color:inherit; cursor:pointer}:is(#gt-locator,.gt-locator) ::selection{background:var(--accent); color:#060606}:is(#gt-locator,.gt-locator) .app{display:grid; grid-template-columns:var(--panel-w) 1fr; height:100%; overflow:hidden}:is(#gt-locator,.gt-locator) .panel{background:linear-gradient(197deg, #121111 18%, #070707 100%); border-right:1px solid var(--line); display:flex; flex-direction:column; min-height:0; min-width:0; position:relative; z-index:2}:is(#gt-locator,.gt-locator) .map-wrap{position:relative; min-width:0; background:var(--bg)}:is(#gt-locator,.gt-locator) #gt-map{position:absolute; inset:0}:is(#gt-locator,.gt-locator) .head{padding:14px 16px 12px; border-bottom:1px solid var(--line); flex:0 0 auto}:is(#gt-locator,.gt-locator) .search{position:relative}:is(#gt-locator,.gt-locator) .search input{
    width:100%; padding:12px 48px 12px 40px; border:1px solid var(--line-str);
    background:#131313; color:var(--ink); border-radius:999px;
    font:500 15px/1.4 inherit; letter-spacing:-.01em;
    outline:none; transition:.15s;
  }:is(#gt-locator,.gt-locator) .search input:hover{border-color:rgba(255,255,255,.28)}:is(#gt-locator,.gt-locator) .search input::placeholder{color:var(--faint)}:is(#gt-locator,.gt-locator) .search input::-webkit-search-cancel-button, :is(#gt-locator,.gt-locator) .search input::-webkit-search-decoration{-webkit-appearance:none; appearance:none; display:none}:is(#gt-locator,.gt-locator) .search input:focus{border-color:var(--accent-line); box-shadow:0 0 0 3px var(--accent-dim)}:is(#gt-locator,.gt-locator) .search .ico{position:absolute; left:14px; top:50%; transform:translateY(-50%); color:var(--faint); pointer-events:none}:is(#gt-locator,.gt-locator) .search .clear{position:absolute; right:46px; top:50%; transform:translateY(-50%); border:0; background:transparent; color:var(--muted); padding:6px 10px; border-radius:999px; display:none}:is(#gt-locator,.gt-locator) .search .clear:hover{background:var(--hover); color:var(--ink)}:is(#gt-locator,.gt-locator) .geo{
    position:absolute; right:4px; top:50%; transform:translateY(-50%);
    width:36px; height:36px; display:grid; place-items:center; padding:0;
    border:0; color:#060606; background:var(--accent); border-radius:50%; transition:.15s;
  }:is(#gt-locator,.gt-locator) .geo svg{width:18px; height:18px}:is(#gt-locator,.gt-locator) .geo:hover{background:#3bff3b}:is(#gt-locator,.gt-locator) .geo[disabled]{opacity:.5; cursor:default}:is(#gt-locator,.gt-locator) .geo.attesa svg{animation:gt-gira 1s linear infinite}@keyframes gt-gira{to{transform:rotate(360deg)}}:is(#gt-locator,.gt-locator) .esito-geo{margin:7px 2px 0; font-size:12px; font-weight:600; color:var(--muted); letter-spacing:-.01em}:is(#gt-locator,.gt-locator) .esito-geo:empty{display:none}:is(#gt-locator,.gt-locator) .chips{display:flex; flex-wrap:wrap; gap:6px; padding:0 16px 10px; flex:0 0 auto; align-items:center}:is(#gt-locator,.gt-locator) .gruppo{display:contents}:is(#gt-locator,.gt-locator) .chips-wrap{border-bottom:1px solid var(--line); flex:0 0 auto; padding-top:10px}:is(#gt-locator,.gt-locator) .etichetta{margin:0 18px 8px; font-size:10.5px; font-weight:800; letter-spacing:.11em;
             text-transform:uppercase; color:var(--faint)}:is(#gt-locator,.gt-locator) .chip{white-space:nowrap; padding:5px 13px; border:1px solid var(--line); background:transparent; border-radius:999px; font-size:13px; font-weight:600; letter-spacing:-.01em; color:var(--muted); transition:.15s; display:inline-flex; align-items:center; gap:6px}:is(#gt-locator,.gt-locator) .chip:hover{border-color:var(--line-str); color:var(--ink)}:is(#gt-locator,.gt-locator) .chip[aria-pressed="true"]{background:var(--accent); border-color:var(--accent); color:#060606}:is(#gt-locator,.gt-locator) .chip.feat[aria-pressed="true"]{background:var(--accent-dim); border-color:var(--accent); color:var(--accent)}:is(#gt-locator,.gt-locator) .chip .live{width:7px;height:7px;border-radius:50%;background:var(--accent);box-shadow:0 0 7px rgba(0,255,0,.7)}:is(#gt-locator,.gt-locator) #gt-reg{padding:5px 28px 5px 12px; border:1px solid var(--line); background:transparent; border-radius:999px;
       font-size:13px; font-weight:600; letter-spacing:-.01em; color:var(--muted); outline:none}:is(#gt-locator,.gt-locator) #gt-reg:hover{border-color:var(--line-str); color:var(--ink)}:is(#gt-locator,.gt-locator) #gt-reg.attivo{background:var(--accent); border-color:var(--accent); color:#060606}:is(#gt-locator,.gt-locator) #gt-reg option{background:var(--elev); color:var(--ink)}:is(#gt-locator,.gt-locator) .sel{position:relative; display:inline-flex; align-items:center; flex:0 0 auto}:is(#gt-locator,.gt-locator) .sel select{appearance:none; -webkit-appearance:none; -moz-appearance:none; width:auto}:is(#gt-locator,.gt-locator) .sel select::-ms-expand{display:none}:is(#gt-locator,.gt-locator) .sel::after{
    content:''; position:absolute; right:12px; top:50%; width:5.5px; height:5.5px;
    border-right:1.6px solid currentColor; border-bottom:1.6px solid currentColor;
    transform:translateY(-70%) rotate(45deg);
    color:var(--muted); opacity:.85; pointer-events:none; transition:.15s;
  }:is(#gt-locator,.gt-locator) .sel:hover::after{color:var(--ink); opacity:1}:is(#gt-locator,.gt-locator) .sel.attivo::after{color:#060606; opacity:1}:is(#gt-locator,.gt-locator) .bar{display:flex; align-items:center; justify-content:space-between; gap:10px; padding:10px 16px 4px; flex:0 0 auto}:is(#gt-locator,.gt-locator) .bar .count{font-size:13px; color:var(--muted); letter-spacing:-.01em}:is(#gt-locator,.gt-locator) .bar .count b{color:var(--accent); font-weight:800; font-size:15px}:is(#gt-locator,.gt-locator) .ordina{display:inline-flex; align-items:center; flex:0 0 auto;
          border:1px solid var(--line); border-radius:999px; background:var(--elev);
          padding:2px; gap:2px}:is(#gt-locator,.gt-locator) .ordina .seg{padding:3px 12px; border:0; border-radius:999px; background:transparent;
               font-size:13px; font-weight:600; letter-spacing:-.01em; color:var(--muted);
               white-space:nowrap; transition:.15s}:is(#gt-locator,.gt-locator) .ordina .seg:hover{color:var(--ink)}:is(#gt-locator,.gt-locator) .ordina .seg[aria-pressed="true"]{background:rgba(255,255,255,.11); color:var(--ink)}:is(#gt-locator,.gt-locator) .list, :is(#gt-locator,.gt-locator) .dbody{scrollbar-width:thin; scrollbar-color:#2E2E2E var(--panel)}:is(#gt-locator,.gt-locator) .list{flex:1 1 auto; overflow-y:auto; padding:6px 10px 18px; overscroll-behavior:contain}:is(#gt-locator,.gt-locator) .list::-webkit-scrollbar, :is(#gt-locator,.gt-locator) .dbody::-webkit-scrollbar{width:8px}:is(#gt-locator,.gt-locator) .list::-webkit-scrollbar-track, :is(#gt-locator,.gt-locator) .dbody::-webkit-scrollbar-track{background:var(--panel)}:is(#gt-locator,.gt-locator) .list::-webkit-scrollbar-thumb, :is(#gt-locator,.gt-locator) .dbody::-webkit-scrollbar-thumb{
    background:#2E2E2E; border-radius:10px;
    border:2px solid var(--panel);   
  }:is(#gt-locator,.gt-locator) .list::-webkit-scrollbar-thumb:hover, :is(#gt-locator,.gt-locator) .dbody::-webkit-scrollbar-thumb:hover{background:#3D3D3D}:is(#gt-locator,.gt-locator) .item{
    display:block; width:100%; text-align:left;
    border:1px solid var(--line); background:rgba(255,255,255,.025);
    padding:11px 13px; border-radius:var(--r-md); transition:.12s; margin-bottom:8px;
  }:is(#gt-locator,.gt-locator) .item:hover{background:rgba(255,255,255,.055); border-color:rgba(255,255,255,.16)}:is(#gt-locator,.gt-locator) .item.hot{background:rgba(255,255,255,.075); border-color:rgba(255,255,255,.24)}:is(#gt-locator,.gt-locator) .item.on{background:rgba(255,255,255,.10); border-color:rgba(255,255,255,.32)}:is(#gt-locator,.gt-locator) .item .top{display:flex; justify-content:space-between; align-items:flex-start; gap:10px}:is(#gt-locator,.gt-locator) .item h3{margin:0 0 4px; font-family:"Inter Tight",Inter,system-ui,sans-serif;
           font-size:16.5px; font-weight:700; letter-spacing:-.025em; color:#F5F5F5;
           line-height:1.2}:is(#gt-locator,.gt-locator) .sede{color:var(--accent)}:is(#gt-locator,.gt-locator) .item p{margin:0; font-size:12px; line-height:1.32; color:rgba(255,255,255,.48);
          letter-spacing:-.005em}:is(#gt-locator,.gt-locator) .tag{font-size:11px; font-weight:700; letter-spacing:.01em; padding:3px 9px; border-radius:999px; background:var(--elev); color:var(--muted); border:1px solid var(--line)}:is(#gt-locator,.gt-locator) .tag.km{background:transparent; border-color:var(--line-str); color:var(--muted);
          white-space:nowrap; font-size:11.5px; padding:2px 8px;
          font-variant-numeric:tabular-nums}:is(#gt-locator,.gt-locator) .tag.feat{border-color:transparent; background:var(--accent-dim); color:var(--accent)}:is(#gt-locator,.gt-locator) .empty{padding:40px 20px; text-align:center; color:var(--muted); font-size:14px}:is(#gt-locator,.gt-locator) .st{display:inline-flex; align-items:center; gap:6px; font-size:12px; font-weight:600; letter-spacing:-.01em; margin-top:6px}:is(#gt-locator,.gt-locator) .st i{width:6px;height:6px;border-radius:50%;display:inline-block;flex:0 0 auto}:is(#gt-locator,.gt-locator) .dbody .st{font-size:13px}:is(#gt-locator,.gt-locator) .dbody .st i{width:7px;height:7px}:is(#gt-locator,.gt-locator) .st.open{color:var(--muted)}:is(#gt-locator,.gt-locator) .st.open i{background:var(--accent); box-shadow:0 0 7px rgba(0,255,0,.65)}:is(#gt-locator,.gt-locator) .st.open b{color:var(--accent); font-weight:800}:is(#gt-locator,.gt-locator) .st.shut b{color:rgba(255,255,255,.72); font-weight:800}:is(#gt-locator,.gt-locator) .st.shut{color:var(--muted)}:is(#gt-locator,.gt-locator) .st.shut i{background:rgba(255,255,255,.32)}:is(#gt-locator,.gt-locator) .st.soon{color:#D8D8D8; align-items:flex-start; line-height:1.35}:is(#gt-locator,.gt-locator) .st.soon i{margin-top:4px}:is(#gt-locator,.gt-locator) .st.soon i{background:transparent; border:2px solid rgba(255,255,255,.5); box-sizing:border-box}:is(#gt-locator,.gt-locator) .detail{position:absolute; inset:0; background:linear-gradient(197deg, #121111 18%, #070707 100%); display:flex; flex-direction:column; transform:translateX(-100%); transition:transform .26s cubic-bezier(.4,0,.2,1); z-index:3}:is(#gt-locator,.gt-locator) .detail.open{transform:none}:is(#gt-locator,.gt-locator) .dhead{padding:12px 18px 14px; border-bottom:1px solid var(--line); flex:0 0 auto}:is(#gt-locator,.gt-locator) .back{display:inline-flex; align-items:center; gap:6px; border:0; background:transparent; color:var(--muted); padding:6px 12px 6px 8px; margin:0 0 10px -8px; border-radius:999px; font-size:13.5px; font-weight:500}:is(#gt-locator,.gt-locator) .back:hover{background:var(--hover); color:var(--ink)}:is(#gt-locator,.gt-locator) .dhead h2{margin:0 0 3px; font-size:22px; font-weight:800; letter-spacing:-.035em; color:#F5F5F5; line-height:1.15}:is(#gt-locator,.gt-locator) .dhead .addr{margin:0; color:var(--muted); font-size:13px; letter-spacing:-.005em; line-height:1.35}:is(#gt-locator,.gt-locator) .dbody{flex:1 1 auto; overflow-y:auto; padding:16px 18px 24px; overscroll-behavior:contain;
         container-type:inline-size}@container (max-width:300px){:is(#gt-locator,.gt-locator) .dbody .btn .pre{display:none}:is(#gt-locator,.gt-locator) .dbody .btn{padding:9px 11px; gap:5px}
  }:is(#gt-locator,.gt-locator) .actions{display:flex; gap:8px; flex-wrap:wrap; margin-bottom:20px}:is(#gt-locator,.gt-locator) .btn{display:inline-flex; align-items:center; gap:7px; padding:9px 16px; border-radius:999px; border:1px solid var(--line); background:transparent; font-size:14px; font-weight:700; letter-spacing:-.01em; text-decoration:none; color:var(--ink); transition:.15s}:is(#gt-locator,.gt-locator) .btn:hover{border-color:var(--line-str); background:var(--hover)}:is(#gt-locator,.gt-locator) .btn.solid{background:rgba(255,255,255,.10); border-color:var(--line-str); color:var(--ink)}:is(#gt-locator,.gt-locator) .btn.solid:hover{background:rgba(255,255,255,.15); border-color:rgba(255,255,255,.28)}:is(#gt-locator,.gt-locator) .btn.solid svg{color:var(--accent)}:is(#gt-locator,.gt-locator) .btn svg{flex:0 0 auto}:is(#gt-locator,.gt-locator) .btn .pre{color:var(--faint); font-weight:600; margin-right:2px}:is(#gt-locator,.gt-locator) .btn .num{font-variant-numeric:tabular-nums}:is(#gt-locator,.gt-locator) .hero{position:relative; margin:-16px -18px 16px; aspect-ratio:16/9; background:var(--elev); overflow:hidden}:is(#gt-locator,.gt-locator) .hero img{width:100%; height:100%; object-fit:cover; display:block}:is(#gt-locator,.gt-locator) .hero::after{content:""; position:absolute; inset:auto 0 0 0; height:56px;
               background:linear-gradient(to top, var(--panel), transparent); pointer-events:none}:is(#gt-locator,.gt-locator) .sec{margin-bottom:20px}:is(#gt-locator,.gt-locator) .sec h4{margin:0 0 9px; font-size:11.5px; font-weight:800; letter-spacing:.07em; text-transform:uppercase; color:var(--muted)}:is(#gt-locator,.gt-locator) .hours{display:grid; grid-template-columns:78px 1fr; gap:6px 10px; background:rgba(255,255,255,.025); border:1px solid var(--line); border-radius:var(--r-md); padding:12px 14px; font-size:13.5px}:is(#gt-locator,.gt-locator) .hours dt{color:var(--muted); font-weight:700}:is(#gt-locator,.gt-locator) .hours dd{margin:0; color:rgba(255,255,255,.86); font-variant-numeric:tabular-nums}:is(#gt-locator,.gt-locator) .hours .now{color:var(--accent); font-weight:800}:is(#gt-locator,.gt-locator) .feats{display:flex; gap:7px; flex-wrap:wrap}:is(#gt-locator,.gt-locator) .vicine{display:flex; flex-direction:column; gap:6px}:is(#gt-locator,.gt-locator) .vic{display:flex; align-items:center; justify-content:space-between; gap:10px; width:100%;
       padding:8px 12px; border:1px solid var(--line); border-radius:var(--r-md);
       background:rgba(255,255,255,.025); color:var(--ink); text-align:left;
       font-family:"Inter Tight",Inter,system-ui,sans-serif; font-size:15px; font-weight:700;
       letter-spacing:-.02em; transition:.12s}:is(#gt-locator,.gt-locator) .vic .tag.km{background:transparent; border-color:var(--line-str); color:var(--muted);
               font-weight:700; font-size:12px; padding:2px 9px}:is(#gt-locator,.gt-locator) .vic:hover{background:rgba(255,255,255,.055); border-color:rgba(255,255,255,.16)}:is(#gt-locator,.gt-locator) .me-pin{position:relative; width:16px; height:16px; border-radius:50%;
          background:#2F7DFF; border:3px solid #FFFFFF;
          box-shadow:0 1px 4px rgba(0,0,0,.6), 0 0 0 1px rgba(0,0,0,.35)}:is(#gt-locator,.gt-locator) .me-pin::after{content:''; position:absolute; inset:-3px; border-radius:50%;
                 border:2px solid rgba(47,125,255,.55); animation:gt-battito 2.4s ease-out infinite}@keyframes gt-battito{
    0%{transform:scale(1); opacity:.75}
    70%{transform:scale(2.6); opacity:0}
    100%{transform:scale(2.6); opacity:0}
  }@media (prefers-reduced-motion:reduce){:is(#gt-locator,.gt-locator) .me-pin::after{animation:none; opacity:.5} }:is(#gt-locator,.gt-locator) .loading{position:absolute; inset:0; display:grid; place-items:center; background:var(--bg); color:var(--muted); font-size:14px; text-align:center; padding:20px; z-index:5}:is(#gt-locator,.gt-locator) .maplibregl-popup-content{background:var(--elev); color:var(--ink); border:1px solid var(--line); border-radius:var(--r-md); padding:10px 13px; box-shadow:var(--shadow); font:inherit}:is(#gt-locator,.gt-locator) .maplibregl-popup-content b{display:block; font-size:13.5px; margin-bottom:1px; font-family:"Inter Tight",Inter,sans-serif}:is(#gt-locator,.gt-locator) .maplibregl-popup-content small{color:var(--muted)}:is(#gt-locator,.gt-locator) .maplibregl-popup-anchor-top .maplibregl-popup-tip{border-bottom-color:var(--elev)}:is(#gt-locator,.gt-locator) .maplibregl-popup-anchor-bottom .maplibregl-popup-tip{border-top-color:var(--elev)}:is(#gt-locator,.gt-locator) .maplibregl-popup-anchor-left .maplibregl-popup-tip{border-right-color:var(--elev)}:is(#gt-locator,.gt-locator) .maplibregl-popup-anchor-right .maplibregl-popup-tip{border-left-color:var(--elev)}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-group{background:var(--elev); border:1px solid var(--line); box-shadow:none}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-group button+button{border-top-color:var(--line)}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-group button .maplibregl-ctrl-icon{filter:invert(1) brightness(.9)}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-group button:hover{background:rgba(255,255,255,.08)}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib{background:rgba(0,0,0,.5)!important; color:var(--faint); font-size:10px; line-height:1.4}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib a{color:var(--muted)}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib.maplibregl-compact{min-height:22px; border-radius:999px}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib-button{background-repeat:no-repeat; background-position:center; background-size:14px}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}:is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib.maplibregl-compact:hover .maplibregl-ctrl-attrib-inner, :is(#gt-locator,.gt-locator) .maplibregl-ctrl-attrib.maplibregl-compact:focus-within .maplibregl-ctrl-attrib-inner{display:block}:is(#gt-locator,.gt-locator) .gt-fs svg{width:16px; height:16px; display:block; margin:auto; color:var(--ink)}:is(#gt-locator,.gt-locator) .gt-fs .x{display:none}:is(#gt-locator,.gt-locator) .app.fs .gt-fs .x{display:block}:is(#gt-locator,.gt-locator) .app.fs .gt-fs .o{display:none}:is(#gt-locator,.gt-locator) .app.fs .gt-esci{background:var(--accent); border-color:var(--accent)}:is(#gt-locator,.gt-locator) .app.fs .gt-esci button:hover{background:rgba(0,0,0,.12)}:is(#gt-locator,.gt-locator) .app.fs .gt-esci svg{color:#060606}body.fs-lock{overflow:hidden}:is(#gt-locator,.gt-locator) .app.fs{
    position:fixed; inset:0; z-index:9998; width:100vw; height:100%;
    grid-template-columns:1fr; grid-template-rows:1fr; background:var(--bg);
  }:is(#gt-locator,.gt-locator) .app.fs > .map-wrap{grid-area:1/1; order:0; border-radius:0}:is(#gt-locator,.gt-locator) .app.fs > .panel{
    grid-area:1/1; order:0; z-index:3;
    width:min(400px, 34vw); margin:16px; height:calc(100% - 32px);
    border:1px solid var(--line-str); border-radius:var(--r-lg); overflow:hidden;
    background:rgba(10,10,10,.82); box-shadow:var(--shadow);
    -webkit-backdrop-filter:blur(18px) saturate(1.3); backdrop-filter:blur(18px) saturate(1.3);
  }@supports not (backdrop-filter:blur(1px)){:is(#gt-locator,.gt-locator) .app.fs > .panel{background:rgba(10,10,10,.96)}
  }:is(#gt-locator,.gt-locator) .maniglia{
    display:none; width:100%; flex:0 0 auto; padding:10px 0 6px;
    background:transparent; border:0; touch-action:none; cursor:grab;
  }:is(#gt-locator,.gt-locator) .maniglia::before{
    content:''; display:block; width:42px; height:4px; margin:0 auto;
    border-radius:999px; background:rgba(255,255,255,.28);
  }:is(#gt-locator,.gt-locator) .maniglia:active{cursor:grabbing}:is(#gt-locator,.gt-locator) .maniglia:active::before{background:rgba(255,255,255,.5)}@media (max-width:860px){:is(#gt-locator,.gt-locator) .app{grid-template-columns:1fr; grid-template-rows:var(--gt-h-map) 1fr}:is(#gt-locator,.gt-locator) .map-wrap{order:1}:is(#gt-locator,.gt-locator) .panel{order:2; border-right:0; border-top:1px solid var(--line)}:is(#gt-locator,.gt-locator) .head{padding:10px 14px 9px}:is(#gt-locator,.gt-locator) .chips-wrap{padding-top:7px}:is(#gt-locator,.gt-locator) .chips{padding:0 14px 8px}:is(#gt-locator,.gt-locator) .bar{padding:7px 14px 2px}:is(#gt-locator,.gt-locator) .app.fs{grid-template-rows:1fr}:is(#gt-locator,.gt-locator) .app.fs > .panel{
      width:auto; margin:0; align-self:end;
      height:var(--gt-foglio, 55dvh); max-height:85dvh;
      border-radius:22px 22px 0 0; border-bottom:0;
      transition:height .28s cubic-bezier(.4,0,.2,1);
    }:is(#gt-locator,.gt-locator) .app.fs.trascino > .panel{transition:none}:is(#gt-locator,.gt-locator) .app.fs .maniglia{display:block}:is(#gt-locator,.gt-locator) .app.fs .maplibregl-ctrl-zoom-in, :is(#gt-locator,.gt-locator) .app.fs .maplibregl-ctrl-zoom-out{display:none}:is(#gt-locator,.gt-locator) .app.fs .maplibregl-ctrl-top-right{
      top:calc(env(safe-area-inset-top, 0px) + 2px);
      right:calc(env(safe-area-inset-right, 0px) + 2px);
    }:is(#gt-locator,.gt-locator) .app.fs .gt-fs button{width:44px; height:44px}:is(#gt-locator,.gt-locator) .app.fs .gt-fs svg{width:19px; height:19px}
  }@media (max-width:400px), (max-width:860px) and (min-aspect-ratio:13/10){:is(#gt-locator,.gt-locator) .actions{gap:6px}:is(#gt-locator,.gt-locator) .btn{padding:9px 13px}
  }@media (max-width:860px) and (min-aspect-ratio:13/10){:is(#gt-locator,.gt-locator) .app{grid-template-columns:minmax(230px, 46%) 1fr; grid-template-rows:1fr}:is(#gt-locator,.gt-locator) .map-wrap{order:2}:is(#gt-locator,.gt-locator) .panel{order:1; border-top:0; border-right:1px solid var(--line)}
  }
`;
const HTML = `<div class="app" id="gt-scena">
  <aside class="panel">
    <!-- Solo a schermo intero da telefono: l'elenco diventa un foglio che si
         trascina sopra la mappa. Fuori da li' resta nascosta. -->
    <button class="maniglia" id="gt-maniglia" aria-label="Trascina per ingrandire o ridurre l'elenco"></button>
    <div class="head">
      <div class="search">
        <svg class="ico" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
        <!-- type="text" e non "search": WebKit su input[type=search] disegna una X sua,
           che si sommava alla nostra. Il pulsante di pulizia e' il nostro. -->
        <input id="gt-q" type="text" inputmode="search" placeholder="Città, provincia o nome sede" autocomplete="off">
        <button class="clear" id="gt-qclear" aria-label="Pulisci">✕</button>
        <!-- La posizione è un'alternativa alla ricerca, non un'azione a parte:
             sta dentro la barra, come nelle app di mappe. -->
        <button class="geo" id="gt-geo" title="Cerca vicino a me" aria-label="Cerca vicino a me">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><circle cx="12" cy="12" r="8"/><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3"/></svg>
        </button>
      </div>
      <p class="esito-geo" id="gt-esito-geo" role="status"></p>
    </div>

    <div class="chips-wrap">
      <div class="chips">
        <!-- il contenitore dei filtri viene svuotato a ogni ridisegno: il menu
             delle regioni gli sta accanto, non dentro, o sparirebbe. -->
        <span id="gt-chips-feat" class="gruppo"></span>
        <span class="sel"><select id="gt-reg" aria-label="Filtra per regione"></select></span>
      </div>
    </div>

    <div class="bar">
      <div class="count" id="gt-count"></div>
      <!-- Due sole scelte: una tendina obbligava a due gesti (apri, scegli) per
           vedere una cosa che ci sta tutta in una riga. Qui si vedono e si toccano. -->
      <div class="ordina" id="gt-sort" role="group" aria-label="Ordina l'elenco">
        <button type="button" class="seg" data-v="name" aria-pressed="true">Nome</button>
        <button type="button" class="seg" data-v="distance" aria-pressed="false">Vicine</button>
      </div>
    </div>

    <div class="list" id="gt-list"></div>

    <section class="detail" id="gt-detail" aria-hidden="true">
      <div class="dhead">
        <button class="back" id="gt-back">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14 6-6 6 6 6"/></svg>
          Tutte le palestre
        </button>
        <h2 id="gt-dname"></h2>
        <p class="addr" id="gt-daddr"></p>
      </div>
      <div class="dbody" id="gt-dbody"></div>
    </section>
  </aside>

  <div class="map-wrap" id="gt-mapwrap">
    <div id="gt-map"></div>
    <div class="loading" id="gt-loading">Carico la mappa…</div>
  </div>
</div>`;

/* Il foglio di stile entra una volta sola, anche se il locator compare due volte. */
function stile(){
  if (document.getElementById('gt-locator-stile')) return;
  const s = document.createElement('style');
  s.id = 'gt-locator-stile';
  s.textContent = CSS;
  document.head.appendChild(s);
}

function avviaSu(ROOT){
/* GreenTheory — locator palestre. Blocco autonomo, generato da build/blocco.py.
   Non modificare a mano: si rigenera con `python3 build/blocco.py`.
   I dati delle sedi arrivano dal foglio, via Worker: vedi DATI_URL qui sotto. */

const DATI_URL = window.GT_SEDI_URL || 'https://mappa-greentheory.developer-7c5.workers.dev/sedi.json';
const CDN = {
  maplibreJs:  ['https://cdnjs.cloudflare.com/ajax/libs/maplibre-gl/5.24.0/maplibre-gl.js',  'sha384-5+cfbwT0iiub6VsQAdn6yz16nr6sDiQoHx6tm4O8OVYXHYOxcffFmCJBL0dgdvGp'],
  maplibreCss: ['https://cdnjs.cloudflare.com/ajax/libs/maplibre-gl/5.24.0/maplibre-gl.css', 'sha384-uTttxo/aOKbdE5RlD/SPzSDoDmNvGlUYPjONi2MN/b7c9HPSvW07OIuyP7uL6jxK'],
  pmtiles:     ['https://cdn.jsdelivr.net/npm/pmtiles@4.5.0/dist/pmtiles.js',      'sha384-pbKNZbDshUsLnZMIVsn/t+j3xEY9PGfuX5Z22l5rcy/obXz3EwaMx1F5d9sRsJMn'],
};

/* Carica un foglio di stile o uno script una volta sola, con l'impronta del file.
   Se il blocco compare due volte nella pagina, la libreria si scarica comunque una
   volta sola: la promessa e' condivisa. */
const _caricati = (window.__gtCdn = window.__gtCdn || {});
function risorsa(tipo, url, sri){
  if (_caricati[url]) return _caricati[url];
  return _caricati[url] = new Promise((ok, ko) => {
    const el = document.createElement(tipo === 'css' ? 'link' : 'script');
    if (tipo === 'css') { el.rel = 'stylesheet'; el.href = url; } else { el.src = url; }
    el.integrity = sri;
    el.crossOrigin = 'anonymous';
    el.onload = ok;
    el.onerror = () => ko(new Error('risorsa non caricata: ' + url));
    document.head.appendChild(el);
  });
}

/* ---- logica aperto/chiuso (src/orari.js, coperta da test/orari.test.mjs) ---- */
const _orariHost = {};
/* Logica orari — l'unico punto dove si decide "aperto o chiuso".
   Sta in un file suo perché è la parte con i bug: mezzanotte, sabato, domenica,
   H24, fuso orario. Qui è pura e testabile (test/orari.test.mjs) e la stessa
   funzione la usa anche la validazione dei dati (build/validate.mjs). */
(function (root) {
  'use strict';

  var TZ     = 'Europe/Rome';
  /* Scritto a mano nel foglio, quindi tollerante sulle varianti non ambigue:
       "05:30 - 23:00"   canonico
       "05.30 - 23.00"   punto al posto dei due punti
       "06:00 - 21"      minuti sottintesi
       "08:00 20:00"     trattino dimenticato
     Resta rifiutato tutto il resto: meglio bloccare il deploy che mostrare un
     orario inventato. */
  var RANGE  = /(\d{1,2})(?:[:.](\d{2}))?\s*(?:[-–—]\s*|\s+)(\d{1,2})(?:[:.](\d{2}))?(?!\s*[:.]?\d)/;
  var H24    = /h\s*-?\s*24|24\s*\/\s*7|\b24h\b/i;
  var CHIUSO = /chius/i;
  var GIORNI = ['Lun-Ven', 'Sabato', 'Domenica'];

  // Ora di Roma, non del visitatore: chi apre la pagina da un altro fuso deve
  // vedere lo stesso stato di chi è davanti alla palestra.
  function romeNow(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(date || new Date());
    var get = function (t) { return parts.find(function (p) { return p.type === t; }).value; };
    var DAY = {Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6};
    return {day: DAY[get('weekday')], mins: +get('hour') * 60 + +get('minute')};
  }

  // "05:30 - 23:00 / Sab 05:30 - 22:00 / Dom chiuso" -> {feriali, sab, dom}
  function parseOrario(raw) {
    if (raw == null) return null;
    var s = String(raw).trim();
    if (!s) return null;
    if (H24.test(s)) return {h24: true};

    var feriali = '', sab = '', dom = '';
    s.split('/').map(function (x) { return x.trim(); }).filter(Boolean).forEach(function (p) {
      if (/^sab/i.test(p))      sab = p.replace(/^sab\S*/i, '').trim();
      else if (/^dom/i.test(p)) dom = p.replace(/^dom\S*/i, '').trim();
      else                      feriali = p;
    });
    if (!feriali && !sab && !dom) return null;
    if (!sab) sab = feriali;
    if (!dom) dom = feriali;
    return {h24: false, feriali: feriali, sab: sab, dom: dom};
  }

  // `end` può superare 1440 quando la chiusura è dopo mezzanotte.
  function within(mins, start, end) {
    if (mins >= start && mins < end) return true;
    if (end > 1440) {
      var m = mins + 1440;
      if (m >= start && m < end) return true;
    }
    return false;
  }

  var pad = function (h, m) {
    return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
  };

  // Estrae {h1,m1,h2,m2} da una fascia oraria, o null se non è leggibile.
  // Rifiuta ore > 23 e minuti > 59: "25:00" è un errore di battitura, non un orario.
  function leggiRange(s) {
    var m = String(s || '').match(RANGE);
    if (!m) return null;
    var t = {h1: +m[1], m1: m[2] ? +m[2] : 0, h2: +m[3], m2: m[4] ? +m[4] : 0};
    if (t.h1 > 23 || t.h2 > 23 || t.m1 > 59 || t.m2 > 59) return null;
    return t;
  }

  /* Restituisce:
       {state:'open'|'shut'|'unknown', text?, rows?: [[label,valore]], oggi?: indice}
     'unknown' quando l'orario manca o è illeggibile: meglio non dire niente che
     inventare un "chiuso" sbagliato. */
  function statoOra(raw, now) {
    var o = parseOrario(raw);
    if (!o) return {state: 'unknown'};
    if (o.h24) return {state: 'open', text: 'Aperto · H24', rows: [['Sempre', 'Aperto H24']], oggi: 0};

    var n = now || romeNow();
    var idx = n.day === 6 ? 1 : n.day === 0 ? 2 : 0;
    var vals = [o.feriali, o.sab, o.dom];
    var rows = GIORNI.map(function (g, i) { return [g, vals[i] || '—']; });
    var oggi = vals[idx];

    if (!oggi || CHIUSO.test(oggi)) return {state: 'shut', text: 'Chiuso oggi', rows: rows, oggi: idx};

    var t = leggiRange(oggi);
    if (!t) return {state: 'unknown', rows: rows, oggi: idx};

    var start = t.h1 * 60 + t.m1;
    var end   = t.h2 * 60 + t.m2;
    if (end <= start) end += 1440;                    // chiude dopo mezzanotte

    return within(n.mins, start, end)
      ? {state: 'open', text: 'Aperto · chiude alle ' + pad(t.h2, t.m2), rows: rows, oggi: idx}
      : {state: 'shut', text: 'Chiuso · apre alle '  + pad(t.h1, t.m1), rows: rows, oggi: idx};
  }

  function isH24(raw) { return H24.test(String(raw || '')); }

  // Vero se la stringa è comprensibile: usata dalla validazione per bloccare
  // il deploy quando qualcuno scrive un orario in un formato nuovo.
  function orarioValido(raw) {
    if (raw == null || !String(raw).trim()) return true;   // assente è lecito
    var o = parseOrario(raw);
    if (!o) return false;
    if (o.h24) return true;
    return [o.feriali, o.sab, o.dom].every(function (v) {
      return !v || CHIUSO.test(v) || !!leggiRange(v);
    });
  }

  root.Orari = {romeNow: romeNow, parseOrario: parseOrario, statoOra: statoOra,
                isH24: isH24, orarioValido: orarioValido};
})(_orariHost);

const Orari = _orariHost.Orari;
/* ---- fine logica aperto/chiuso ---- */

/* ============================================================
   CONFIG
   ============================================================ */
// Tessere servite da noi: un solo file .pmtiles su Cloudflare R2, dietro un Worker
// che aggiunge cache e blocco hotlink. Costo fisso di pochi euro l'anno, nessun
// fornitore esterno sulla strada critica.
/* Il recinto della mappa, in gradi: [[ovest, sud], [est, nord]].
   E' esattamente il ritaglio del file delle tessere: piu' aria di cosi' non ce
   n'e' da dare, e nemmeno un pixel di vuoto da vedere. Le tessere che toccano
   questo rettangolo lo contengono sempre, a qualsiasi ingrandimento. */
const RECINTO = [[6.6, 35.4], [18.6, 47.1]];

/* Le tessere passano dal Worker, e ogni pezzo di file letto e' una richiesta che
   Cloudflare conta. Servendole da un dominio di R2 quelle richieste escono dal
   conto dei Workers ed entrano in quello di R2, dove dieci milioni al mese sono
   compresi. Per provare basta una riga nella pagina, prima dello script:
       window.GT_TILES_URL = "https://tiles.greentheory.it/italia.pmtiles";
   Se qualcosa non va, si toglie la riga e si torna com'era. */
const TILES_URL = window.GT_TILES_URL
  || 'https://mappa-greentheory.developer-7c5.workers.dev/italia.pmtiles';

// Tema scuro ufficiale Protomaps, etichette in italiano. Contiene il layer `pois`:
// negozi, parcheggi e fermate restano visibili come su Google. Prima usavamo liberty
// di OpenFreeMap scurito a mano, perche' i suoi stili scuri i POI non li avevano.
const STYLE_URL = 'https://cdn.jsdelivr.net/npm/protomaps-themes-base@4.5.0/dist/styles/dark/it.json';

const ACCENT = '#00FF00';
const DARK   = '#060606';
const TZ     = 'Europe/Rome';

/* ============================================================
   STATE
   ============================================================ */
let SEDI = [], ME = null, sel = null;
let filterReg = null, query = '', sortBy = 'name';
const feats = {aperto:false, h24:false};
let map = null, popup = null, meMarker = null, mapReady = false;

/* ============================================================
   UTILS
   ============================================================ */
const $ = s => ROOT.querySelector(s);

function haversine(a1, o1, a2, o2){
  const p = Math.PI/180;
  const h = 0.5 - Math.cos((a2-a1)*p)/2 +
            Math.cos(a1*p)*Math.cos(a2*p)*(1-Math.cos((o2-o1)*p))/2;
  return 12742000*Math.asin(Math.sqrt(h));   // metri
}
const fmtM  = m => m < 1000 ? Math.round(m) + ' m'
                            : (m/1000).toFixed(m < 10000 ? 1 : 0).replace('.', ',') + ' km';
const norm  = s => (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
const esc   = s => String(s||'').replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
/* Le sedi non ancora aperte. La mappa Stockist mostra un avviso al posto degli
   orari; qui l'avviso si ricava dai dati che il foglio ha gia', cioe' la colonna
   "stato" del master. Il giorno che qualcuno scrive l'indirizzo e gli orari,
   l'avviso sparisce da solo. */
const daAprire = s => (s.stato || '').toLowerCase().startsWith('da aprire');

/* Cosa scrivere per una sede non ancora aperta: la frase esatta che ha su
   Stockist, parola per parola. Sono di quattro tipi e non seguono una regola —
   Careggi nomina la via, Firenze Piagge ce l'ha ma dice lo stesso "a breve vi
   comunicheremo indirizzo", Scandicci e Pescara hanno una frase loro. Sono state
   scritte a mano in momenti diversi, e le copiamo com'e'.

   Il ripiego serve quando i dati non portano nessuna frase: e' il caso del
   foglio, che le note non le ha. */
const avviso = s => (s.nota || '').trim() || (s.via
  ? 'Stiamo arrivando'
  : 'In arrivo prossimamente, a breve vi comunicheremo indirizzo e data di apertura');


/* 3278717320 -> +39 327 871 7320. Il prefisso resta staccato dal numero, che si
   legge in tre gruppi come lo scriverebbe una persona. Tutti i numeri del foglio
   sono cellulari italiani di dieci cifre; se un giorno ne arriva uno diverso si
   mostra com'e', senza inventarsi una spaziatura sbagliata. */
function fmtTel(t){
  let c = (t || '').replace(/\D/g, '');
  if (c.length === 12 && c.slice(0,2) === '39') c = c.slice(2);
  if (c.length !== 10) return {pre: '', num: t || ''};
  return {pre: '+39', num: c.slice(0,3) + ' ' + c.slice(3,6) + ' ' + c.slice(6)};
}

// La freccia di navigazione: la stessa forma che usa Google Maps per "avviami".
const ICONA_ROTTA = '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
  + '<path d="M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"/></svg>';
const ICONA_TEL = '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">'
  + '<path d="M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11.4 11.4 0 0 0 3.6.58 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1'
  + 'A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.6a1 1 0 0 1-.25 1l-2.22 2.2Z"/></svg>';

/* Il marchio resta bianco come il resto del titolo; in verde va solo il nome
   della sede, che e' quello che si cerca. */
const nomeHtml = s => {
  const m = /^GreenTheory\s+(.+)$/i.exec(s.nome);
  return m ? 'GreenTheory <span class="sede">' + esc(m[1]) + '</span>' : esc(s.nome);
};

/* Il verde dice una cosa sola: aperto adesso. L'ora di chiusura sta in grigio,
   altrimenti il verde non distingue piu' niente. */
const rigaStato = st => {
  const i = st.text.indexOf(' · ');
  return i === -1
    ? '<b>' + esc(st.text) + '</b>'
    : '<b>' + esc(st.text.slice(0, i)) + '</b>' + esc(st.text.slice(i));
};
const RIGA_ATTESA = 'A breve vi comunicheremo indirizzo e data di apertura';

const addr  = s => {
  // Senza via né città resterebbe la sola sigla fra parentesi, che da sola non
  // dice niente: in quel caso è meglio non scrivere l'indirizzo.
  if (!s.via && !s.citta) return '';
  // Nel foglio capita "Via Camozzi,23": la virgola senza spazio si legge male.
  const via = (s.via || '').replace(/,(\S)/g, ', $1');
  /* Stockist a volte infila tutto nel campo della via, sigla compresa: senza
     questo controllo verrebbe "Via de' Cattani, 220G, 50145 Firenze (FI), (FI)".
     E la sigla da sola, senza citta' ne' CAP, non dice niente a nessuno. */
  const giaCompleto = s.sigla && new RegExp('\\(\\s*' + s.sigla + '\\s*\\)', 'i').test(via);
  const dove = [s.cap, s.citta].filter(Boolean).join(' ');
  const loc = giaCompleto ? ''
            : [dove, dove && s.sigla ? '(' + s.sigla + ')' : ''].filter(Boolean).join(' ');
  return [via, loc].filter(Boolean).join(', ');
};

/* ============================================================
   ORARI  ->  src/orari.js
   Vive in un file separato perché è la parte con i bug (mezzanotte, sabato,
   domenica, H24, fuso). Lì è pura e coperta da test/orari.test.mjs, e la stessa
   funzione la usa build/validate.mjs per bloccare il deploy sui dati rotti.
   ============================================================ */
const statoOra = raw => Orari.statoOra(raw);
const isH24    = s   => Orari.isH24(s.orario);

/* ============================================================
   MAP
   ============================================================ */

/* Disegna un segnaposto a goccia e lo restituisce nel formato che vuole MapLibre.
   Si disegna al doppio della misura e si dichiara `pixelRatio: 2`, così resta
   nitido anche sugli schermi ad alta densità. */
/* La sagoma è quella che tutti riconoscono come segnaposto, presa dal set di icone
   Material: testa tonda, fianchi che si stringono, punta netta. Descritta una volta
   sola in coordinate 24×24 e poi ingrandita, invece di ricostruirla con curve a mano
   che a occhio non tornano mai simmetriche.
   Si disegna a tripla risoluzione: a densità minore i bordi curvi vengono seghettati. */
/* Il segnaposto.

   Tre pezzi: una testa tonda, un ago che scende fino al punto esatto, e un occhio
   al centro di colore diverso — quello che rende la sagoma riconoscibile anche
   quando e' larga dieci pixel su una mappa piena di roba.

   L'ago non e' disegnato a mano: dalla punta partono le due rette tangenti alla
   testa, e l'angolo di tangenza si ricava da quanto la punta e' lontana dal
   centro. Cosi' testa e ago si raccordano senza spigoli a qualsiasi misura, e
   piu' la punta e' lontana piu' l'ago si assottiglia.

   Il contorno bianco e' di un pixel: e' quello che usa Stockist, misurato sulla
   sua immagine. Tre pixel, come avevamo prima, facevano vedere il bianco prima
   del verde. */
function pinGoccia(riempimento, bordo, occhio, spessore){
  const s = 3;                    // moltiplicatore di risoluzione
  const R = 11.5;                 // raggio della testa
  const H = 40;                   // altezza totale, punta compresa
  const rOcchio = 4.2;
  const margine = 2;

  const w = Math.round((R * 2 + margine * 2) * s);
  const h = Math.round((H + margine * 2) * s);
  const cv = document.createElement('canvas');
  cv.width = w; cv.height = h;
  const x = cv.getContext('2d');
  x.setTransform(s, 0, 0, s, 0, 0);      // da qui si ragiona in pixel schermo

  const cx = margine + R, cy = margine + R, punta = margine + H;
  const a = Math.acos(R / (punta - cy));

  x.beginPath();
  x.arc(cx, cy, R, Math.PI / 2 - a, Math.PI / 2 + a, true);  // la testa
  x.lineTo(cx, punta);                                       // giu' fino alla punta
  x.closePath();

  x.shadowColor = 'rgba(0,0,0,.4)';
  x.shadowBlur = 1.6;
  x.shadowOffsetY = 0.6;
  x.fillStyle = riempimento;
  x.fill();
  x.shadowColor = 'transparent';

  x.lineWidth = spessore || 1;
  x.strokeStyle = bordo;
  x.lineJoin = 'round';
  x.stroke();

  x.beginPath();
  x.arc(cx, cy, rOcchio, 0, Math.PI * 2);
  x.fillStyle = occhio;
  x.fill();

  return {width: w, height: h, data: new Uint8Array(x.getImageData(0, 0, w, h).data)};
}


function toGeoJSON(list){
  return {type:'FeatureCollection', features:list.map(s => ({
    type:'Feature',
    geometry:{type:'Point', coordinates:[s.lng, s.lat]},
    properties:{id:s.id, nome:s.nome, citta:s.citta, aperto:s._st.state === 'open'}
  }))};
}

async function initMap(){
  /* Insegna a MapLibre a leggere gli indirizzi pmtiles://, che si traducono in
     richieste Range sul file unico invece che in migliaia di file separati.
     `tile` e' una proprieta' dell'istanza, non del prototipo: cercarla fra i metodi
     del prototipo non la trova (li' ci sono solo `add` e `get`, che sono altro). */
  maplibregl.addProtocol('pmtiles', new pmtiles.Protocol().tile);

  let style;
  try{
    style = await fetch(STYLE_URL).then(r => {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
    // Lo stile pubblicato ha un indirizzo segnaposto: lo puntiamo al nostro file.
    style.sources.protomaps.url = 'pmtiles://' + TILES_URL;
  }catch(err){
    console.error('stile non caricato:', err.message);
    const l = $('#gt-loading');
    if (l) l.innerHTML = 'Mappa non disponibile.<br><small>La lista delle palestre funziona lo stesso.</small>';
    return;
  }

  map = new maplibregl.Map({
    container: $('#gt-map'), style, center:[11.6, 43.6], zoom:5.2,
    attributionControl:{compact:true},    // ODbL: obbligatoria, ma può stare compatta

    /* Il locator sta in mezzo a una pagina: senza questo, scorrere con un dito
       sopra la mappa muoveva la mappa invece della pagina, e chi legge restava
       inchiodato lì. Con i gesti cooperativi un dito scorre la pagina, due dita
       spostano la mappa, e da computer lo zoom con la rotella vuole Ctrl o Cmd. */
    /* Le tessere coprono la sola Italia, e a bassi ingrandimenti si vedeva il
       bordo del ritaglio: trascinando verso ovest si finiva nel vuoto. Questo e'
       il recinto: sta dentro l'area che il file copre a ogni livello e contiene
       tutte le palestre con abbondanza. Piu' in la' non si va. */
    maxBounds: RECINTO,

    cooperativeGestures: true,
    locale: {
      'CooperativeGesturesHandler.WindowsHelpText': 'Tieni premuto Ctrl e usa la rotella per ingrandire',
      'CooperativeGesturesHandler.MacHelpText': 'Tieni premuto ⌘ e usa la rotella per ingrandire',
      'CooperativeGesturesHandler.MobileHelpText': 'Usa due dita per spostare la mappa',
    },
  });
  /* MapLibre misura il contenitore una volta sola, alla creazione. Da quando
     l'altezza è quella del riquadro che ospita il locator invece di un valore
     fisso, quella misura può arrivare prima che il riquadro abbia la sua forma
     definitiva: il disegno resta della dimensione vecchia e viene stirato, con
     l'effetto di una mappa sgranata. Qui si rimisura a ogni cambio. */
  if ('ResizeObserver' in window){
    let attesa = null;
    new ResizeObserver(() => {
      clearTimeout(attesa);
      attesa = setTimeout(() => { if (map){ map.resize(); limitaZoom(); } }, 80);
    }).observe($('#gt-mapwrap'));
  }

  map.addControl(new PosizioneGT(), 'top-right');
  map.addControl(new FullscreenGT(), 'top-right');
  map.addControl(new maplibregl.NavigationControl({showCompass:false}), 'top-right');
  /* Il fumetto si apriva a 14px dal punto e finiva sopra il segnaposto, che e'
     alto 38px (45 quello selezionato) e sta in piedi sulla sua punta. Qui lo
     scostamento cambia con il lato: sopra il punto deve scavalcare tutto il
     segnaposto, sotto puo' stare attaccato perche' li' il segnaposto non c'e'. */
  const ALTO = 50;
  popup = new maplibregl.Popup({closeButton:false, offset:{
    'bottom':       [0, -ALTO],
    'bottom-left':  [0, -ALTO],
    'bottom-right': [0, -ALTO],
    'top':          [0, 4],
    'top-left':     [0, 4],
    'top-right':    [0, 4],
    'left':         [10, -ALTO / 2],
    'right':        [-10, -ALTO / 2],
  }});


  /* Tutto quello che rende viva la mappa stava dentro un solo `map.on('load')`.
     Se quell'annuncio non arriva — e dipende da server esterni per caratteri e
     icone — restava la scritta "Carico la mappa..." per sempre, senza segnaposti
     e senza un messaggio. Ora lo stesso lavoro parte al primo fra tre segnali:
     l'annuncio vero, lo stile pronto, o un timone a tempo. Chi arriva secondo
     trova la porta chiusa. */
  let montata = false, koDetto = false;

  function monta(){
    if (montata || !map) return;
    try { montaLivelli(); } catch(err){ return; }   // stile non ancora pronto: si ritenta
    montata = true;
  }

  map.on('load', monta);
  map.on('styledata', () => { if (map.isStyleLoaded()) monta(); });
  setTimeout(monta, 4000);
  setTimeout(monta, 8000);
  setTimeout(() => {
    if (montata) return;
    const l = $('#gt-loading');
    if (l) l.innerHTML = 'Mappa non disponibile.<br><small>L\u2019elenco delle palestre funziona lo stesso.</small>';
    /* Quante volte la mappa non parte sui browser veri. Senza questo si scopre
       solo quando qualcuno si lamenta, e quasi nessuno si lamenta. */
    if (koDetto) return;
    koDetto = true;
    segnala('mappa-ko', {motivo: 'non montata entro 14s'});
  }, 14000);

  /* L'allarme qui sopra guarda se i livelli si montano, e i livelli si montano
     leggendo lo STILE, che arriva da un altro indirizzo. Le tessere no: quelle
     sono nostre. Se muoiono — quota finita, file spostato, bucket sbagliato — lo
     stile arriva lo stesso, i livelli si montano lo stesso e l'allarme tace,
     mentre in pagina resta una mappa vuota con i pin sospesi nel nulla.
     Provato il 12 settembre 2026 puntando le tessere a un file inesistente:
     partivano solo `gt_pronto` e `gt_visto`, nient'altro.

     Come si riconosce, misurato sugli eventi veri di MapLibre:
       tessere vive  ->  otto `data` con `tile.state === 'loaded'`, zero errori
       tessere morte ->  un solo `error` con `sourceId === 'protomaps'`
     Un solo errore, perche' a mancare e' l'intestazione del .pmtiles: fallita
     quella, le singole tessere non vengono nemmeno chieste. Contarli non serve.

     Si suona se e' fallito qualcosa E non e' mai arrivata nessuna tessera da
     quando la pagina e' aperta. Cosi' l'inciampo su una tessera sola non fa
     rumore. Una quota che finisce a meta' sessione qui non la vediamo: la vede
     il visitatore dopo, che parte a freddo. Meglio tacere che gridare a vuoto. */
  let tessereOk = 0, erroreTessere = null, attesaKo = null;

  map.on('data', e => {
    if (e.sourceId === 'protomaps' && e.tile && e.tile.state === 'loaded') tessereOk++;
  });

  map.on('error', e => {
    if (koDetto || !e || e.sourceId !== 'protomaps') return;
    erroreTessere = e.error;
    if (attesaKo) return;
    // Tre secondi di grazia: il tempo perche' una tessera buona smentisca l'allarme.
    attesaKo = setTimeout(() => {
      if (koDetto || tessereOk) return;
      koDetto = true;
      /* Il dettaglio separa casi che si somigliano: 404 il file non c'e' piu',
         429 la quota e' finita, 'rete' non ci siamo arrivati nemmeno a chiedere.
         Si chiama `dettaglio` e non `stato` perche' `stato` lo usa gia'
         gt_sede_aperta per dire aperta o in arrivo: stesso nome, due significati,
         e in GA4 finirebbero mescolati nella stessa dimensione. */
      segnala('mappa-ko', {
        motivo: 'tessere non raggiungibili',
        dettaglio: (erroreTessere && (erroreTessere.status || erroreTessere.message)) || 'rete',
      });
    }, 3000);
  });

  function montaLivelli(){
    limitaZoom();

    /* Le attivita' intorno alla palestra. Nel file delle tessere ci sono tutte
       (il livello "pois" arriva fino allo zoom 15), ma il tema Protomaps ne
       disegna diciannove tipi soltanto: parchi, stazioni, scuole, spiagge. Bar,
       ristoranti, farmacie, supermercati restano nel file e non si vedono.
       Qui si accende tutto il resto, lasciando fuori quelli che il tema disegna
       gia' per non scriverli due volte. La densita' la decide il file: ogni
       luogo porta con se' un `min_zoom`, cioe' da che ingrandimento merita di
       comparire, e noi lo rispettiamo. */
    const GIA_DAL_TEMA = ['beach','forest','marina','park','peak','zoo','garden',
      'bench','aerodrome','station','bus_stop','ferry_terminal','stadium',
      'university','library','school','animal','toilets','drinking_water'];
    const filtroAttivita = ['all',
      ['>=', ['zoom'], ['get','min_zoom']],
      ['!', ['in', ['get','kind'], ['literal', GIA_DAL_TEMA]]],
      ['has', 'name'],
    ];

    map.addLayer({
      id:'attivita-punto', type:'circle', source:'protomaps', 'source-layer':'pois',
      minzoom:14, filter:filtroAttivita,
      paint:{'circle-radius':2.4, 'circle-color':'rgba(255,255,255,.45)'},
    });
    map.addLayer({
      id:'attivita-nome', type:'symbol', source:'protomaps', 'source-layer':'pois',
      minzoom:14, filter:filtroAttivita,
      layout:{'text-field':['coalesce',['get','name:it'],['get','name']],
              'text-font':['Noto Sans Regular'], 'text-size':11,
              'text-anchor':'top', 'text-offset':[0, 0.6], 'text-max-width':8,
              'text-optional':true},
      paint:{'text-color':'rgba(255,255,255,.62)',
             'text-halo-color':'rgba(0,0,0,.85)', 'text-halo-width':1.1},
    });

    /* L'alone della posizione: non e' decorazione, e' il margine d'errore che il
       telefono dichiara. Un pallino secco su un dato preciso a 800 metri racconta
       una precisione che non c'e'. Sta sotto alle palestre, che restano leggibili. */
    map.addSource('mia', {type:'geojson', data:{type:'FeatureCollection', features:[]}});
    map.addLayer({id:'mia-area', type:'fill', source:'mia',
      paint:{'fill-color':'#2F7DFF', 'fill-opacity':0.13}});
    map.addLayer({id:'mia-bordo', type:'line', source:'mia',
      paint:{'line-color':'#2F7DFF', 'line-opacity':0.35, 'line-width':1}});

    /* I gruppi (i cerchi verdi col numero dentro) sono SPENTI di proposito: si e'
       scelto di vedere tutti i segnaposti, anche accavallati, invece di contarli.
       Il codice che li disegna resta qui sotto e continua a funzionare: basta
       rimettere `true` e tornano, senza toccare altro. */
    const RAGGRUPPA = false;

    map.addSource('sedi', {type:'geojson', data:toGeoJSON([]),
      cluster:RAGGRUPPA, clusterRadius:44, clusterMaxZoom:8});

    map.addLayer({id:'cl', type:'circle', source:'sedi', filter:['has','point_count'],
      paint:{'circle-color':ACCENT,
             // rimpiccioliti insieme ai segnaposti, altrimenti i gruppi dominavano
             'circle-radius':['step',['get','point_count'],14,5,17,15,21],
             'circle-stroke-width':2.5, 'circle-stroke-color':DARK}});

    map.addLayer({id:'cl-n', type:'symbol', source:'sedi', filter:['has','point_count'],
      layout:{'text-field':['get','point_count_abbreviated'], 'text-size':12,
              // Protomaps non ha il "Bold": ha Regular, Medium e Italic.
              'text-font':['Noto Sans Medium']},
      paint:{'text-color':DARK}});

    /* Segnaposti a goccia, con la punta sul luogo esatto. Un cerchio indica un
       intorno, una goccia indica un punto: è il motivo per cui tutte le mappe di
       negozi usano questa forma. Le tre immagini si disegnano qui invece di
       caricare dei file, così il blocco resta senza risorse esterne. */
    map.addImage('gt-pin',     pinGoccia(ACCENT,    'rgba(255,255,255,.92)', '#0A3D0A'), {pixelRatio:3});
    map.addImage('gt-pin-off', pinGoccia('#2E6B2E', 'rgba(255,255,255,.85)', '#0C220C'), {pixelRatio:3});
    /* La selezionata e' identica a una sede aperta: stesso verde, stesso occhio
       scuro. Cambia solo il contorno, piu' marcato, e la taglia — il livello
       'pt-on' la disegna al 118%. Niente bianco: la sede scelta non e' di un
       altro tipo, e' la stessa cosa messa in evidenza. */
    map.addImage('gt-pin-sel', pinGoccia(ACCENT, '#FFFFFF', '#0A3D0A', 2), {pixelRatio:3});

    map.addLayer({id:'pt', type:'symbol', source:'sedi', filter:['!',['has','point_count']],
      layout:{'icon-image':['case',['get','aperto'],'gt-pin','gt-pin-off'],
              'icon-anchor':'bottom',
              // senza questo MapLibre nasconde i segnaposti che si toccano, e nelle
              // citta' con piu' sedi ne sparirebbero alcuni
              'icon-allow-overlap':true}});

    map.addLayer({id:'pt-on', type:'symbol', source:'sedi', filter:['==',['get','id'],' '],
      layout:{'icon-image':'gt-pin-sel', 'icon-anchor':'bottom',
              'icon-allow-overlap':true, 'icon-size':1.18}});

    for (const l of ['pt','cl']){
      map.on('mouseenter', l, () => map.getCanvas().style.cursor = 'pointer');
      map.on('mouseleave', l, () => {
        map.getCanvas().style.cursor = '';
        if (l === 'pt'){ popup.remove(); hot(null); }
      });
    }
    map.on('mousemove', 'pt', e => {
      const p = e.features[0].properties;
      popup.setLngLat(e.features[0].geometry.coordinates)
           .setHTML('<b>'+esc(p.nome)+'</b><small>'+esc(p.citta)+'</small>').addTo(map);
      hot(p.id);
    });
    map.on('click', 'pt', e => open(e.features[0].properties.id));
    // Con i gruppi spenti questo non scatta mai: il livello 'cl' resta vuoto.
    map.on('click', 'cl', async e => {
      const f = map.queryRenderedFeatures(e.point, {layers:['cl']})[0];
      if (!f || f.properties.cluster_id == null) return;
      const z = await map.getSource('sedi').getClusterExpansionZoom(f.properties.cluster_id);
      map.easeTo({center:f.geometry.coordinates, zoom:z});
    });

    mapReady = true;
    const l = $('#gt-loading'); if (l) l.remove();
    render();
    /* Se il permesso di posizione è arrivato mentre la mappa si caricava, il
       marcatore e l'inquadratura andavano persi: si applicano adesso. */
    if (ME) mostraMe();
    else fit(visible());
  }
}

/* ============================================================
   DATA
   ============================================================ */
async function boot(){
  try{
    // L'indirizzo dei dati e' sovrascrivibile dall'esterno: su Shopify la sezione
    // imposta window.GT_DATA_URL sull'asset del tema.
    const risposta = await fetch(window.GT_DATA_URL || DATI_URL, {mode:"cors"}).then(r => {
      if (!r.ok) throw new Error("dati HTTP " + r.status);
      return r.json();
    });
    SEDI = Array.isArray(risposta) ? risposta : (risposta.sedi || []);
    if (!SEDI.length) throw new Error("nessuna palestra nei dati");
  }catch(err){
    $('#gt-loading').innerHTML = 'Dati non caricati.<br><small>Serve un server locale: <code>python3 -m http.server</code></small>';
    console.error(err);
    return;
  }
  SEDI.forEach(s => { s._st = statoOra(s.orario); });
  buildChips();
  render();          // la lista e' utilizzabile prima che la mappa esista

  /* Il locator si e' aperto ed e' utilizzabile: e' il denominatore di tutto il
     resto, senza questo non si sa se le ricerche sono tante o poche. */
  segnala('pronto', {palestre: SEDI.length});

  /* ?sede=<id> nell'indirizzo apre quella palestra: serve alle inserzioni, che
     possono portare la gente direttamente sulla sede della loro citta'. */
  try {
    const voluta = new URL(location.href).searchParams.get('sede');
    if (voluta && SEDI.some(x => x.id === voluta)) open(voluta);
  } catch(e){}
}

/* Le tessere che serviamo coprono la sola Italia: un archivio di 4,5 GB su R2.
   Allargando troppo si arriva dove il file non ha niente e la mappa sembra
   tagliata. Il tetto non e' un numero fisso, perche' dipende da quanto e' grande
   il riquadro: si chiede a MapLibre a che ingrandimento ci sta tutta l'Italia e
   si usa quello come limite. Piu' indietro di cosi' non si va, e a un locator
   non serve. */
const BBOX_IT = RECINTO;

function limitaZoom(){
  if (!map) return;
  try {
    const c = map.cameraForBounds(BBOX_IT, {padding: 24});
    /* Niente margine di tolleranza: 0,2 di zoom in meno bastavano, su uno schermo
       alto e stretto, a far spuntare una striscia di vuoto sopra il recinto. */
    if (c && Number.isFinite(c.zoom)) map.setMinZoom(Math.max(3, c.zoom));
  } catch(e){}
}

function fit(list){
  if (!mapReady || !list.length) return;
  const b = new maplibregl.LngLatBounds();
  list.forEach(s => b.extend([s.lng, s.lat]));
  map.fitBounds(b, {padding:{top:60, bottom:60, left:60, right:60}, maxZoom:13, duration:600});
}

/* ============================================================
   FILTRI + LISTA
   ============================================================ */
const FEATS = [
  ['aperto', 'Aperto ora', true],
  ['h24',    'H24',        false],
];

/* Stringe un <select> sull'opzione che si vede.

   Il menu nativo prende la larghezza dell'opzione piu' lunga, quindi con
   "Tutte" scelta il testo restava a sinistra e la freccia in fondo, con un
   buco in mezzo. Si misura il testo dell'opzione corrente con uno span fuori
   schermo e si fissa la larghezza a quella, spazi e bordi compresi. */
function adattaSelect(el){
  const st = getComputedStyle(el);
  const m = document.createElement('span');
  m.style.cssText = 'position:absolute; left:-9999px; top:0; white-space:pre; '
    + 'font-family:' + st.fontFamily + '; font-size:' + st.fontSize
    + '; font-weight:' + st.fontWeight + '; letter-spacing:' + st.letterSpacing;
  const opt = el.options[el.selectedIndex];
  m.textContent = opt ? opt.text : '';
  document.body.appendChild(m);
  const testo = m.getBoundingClientRect().width;
  m.remove();
  const px = n => parseFloat(n) || 0;
  el.style.width = Math.ceil(testo + px(st.paddingLeft) + px(st.paddingRight)
    + px(st.borderLeftWidth) + px(st.borderRightWidth)) + 'px';
}

function buildChips(){
  const cf = $('#gt-chips-feat');
  cf.innerHTML = '';
  FEATS.forEach(([key, lab, live]) => {
    const b = document.createElement('button');
    b.className = 'chip feat';
    b.innerHTML = (live ? '<span class="live"></span>' : '') + lab;
    b.setAttribute('aria-pressed', String(feats[key]));
    b.onclick = () => {
      feats[key] = !feats[key];
      buildChips(); render(); fit(visible());
      // dopo il ridisegno: cosi' `risultati` e' quello che la persona vede davvero
      segnala('filtro', {filtro: key, acceso: feats[key], risultati: visible().length});
    };
    cf.appendChild(b);
  });

  /* Le regioni stanno in un menu a tendina, non in nove pillole: occupavano tre
     righe, cioè lo spazio di due palestre nell'elenco. Il menu resta accanto ai
     filtri e non cresce quando si aggiunge una regione. */
  const regs = [...new Set(SEDI.map(s => s.regione))].sort();
  const sel = $('#gt-reg');
  if (sel.options.length !== regs.length + 1){
    sel.innerHTML = '<option value="">Tutte</option>'
      + regs.map(r => '<option value="' + esc(r) + '">' + esc(r) + '</option>').join('');
    sel.onchange = () => {
      filterReg = sel.value || null;
      if (filterReg) segnala('filtro', {filtro: 'regione', valore: filterReg});
      // il verde va acceso qui: buildChips() gira solo all'avvio e sui filtri
      sel.classList.toggle('attivo', !!filterReg);
      sel.parentElement.classList.toggle('attivo', !!filterReg);
      adattaSelect(sel);
      render(); fit(visible());
    };
  }
  sel.value = filterReg || '';
  sel.classList.toggle('attivo', !!filterReg);
  sel.parentElement.classList.toggle('attivo', !!filterReg);
  adattaSelect(sel);
}

// Ricerca, regione e caratteristiche si SOMMANO (nell'app precedente si
// sovrascrivevano a vicenda e il chip restava acceso senza filtrare).
function visible(){
  const q = norm(query);
  let list = SEDI.filter(s =>
    (!filterReg   || s.regione === filterReg) &&
    (!feats.aperto|| s._st.state === 'open') &&
    (!feats.h24   || isH24(s)) &&
    (!q || norm([s.nome, s.citta, s.provincia, s.sigla, s.regione, s.cap, s.via].join(' ')).includes(q))
  );
  if (ME) list = list.map(s => ({...s, d: haversine(ME.lat, ME.lng, s.lat, s.lng)}));
  if (sortBy === 'distance' && ME) list.sort((a, b) => a.d - b.d);
  else list.sort((a, b) => a.nome.localeCompare(b.nome, 'it'));
  return list;
}

function render(){
  const list = visible();
  if (mapReady) map.getSource('sedi').setData(toGeoJSON(list));

  $('#gt-count').innerHTML = list.length === SEDI.length
    ? '<b>' + SEDI.length + '</b> palestre'
    : '<b>' + list.length + '</b> di ' + SEDI.length + ' palestre';

  const el = $('#gt-list');
  if (!list.length){
    el.innerHTML = '<div class="empty">Nessuna palestra trovata.<br>Prova a togliere un filtro.</div>';
    return;
  }

  el.innerHTML = list.map(s => {
    const st = s._st;
    const attesa = daAprire(s);
    const stHtml = attesa                ? '<div class="st soon"><i></i>' + esc(avviso(s)) + '</div>'
                 : st.state === 'open'  ? '<div class="st open"><i></i>' + rigaStato(st) + '</div>'
                 : st.state === 'shut'  ? '<div class="st shut"><i></i>' + rigaStato(st) + '</div>' : '';
    return '<button class="item' + (sel === s.id ? ' on' : '') + '" data-id="' + s.id + '">'
      + '<div class="top"><div>'
      +   '<h3>' + nomeHtml(s) + '</h3>'
      +   '<p>' + (esc(addr(s)) || esc(s.citta)
                     || (attesa && !(s.nota || '').trim() ? RIGA_ATTESA : '')) + '</p>'
      +   stHtml
      + '</div>'
      + (s.d != null ? '<span class="tag km">' + fmtM(s.d) + '</span>' : '')
      + '</div>'
      + '</button>';
  }).join('');

  el.querySelectorAll('.item').forEach(b => {
    b.onclick      = () => open(b.dataset.id);
    b.onmouseenter = () => hot(b.dataset.id, false);
    b.onmouseleave = () => hot(null, false);
  });
}

function hot(id, fromMap = true){
  ROOT.querySelectorAll('.item').forEach(b =>
    b.classList.toggle('hot', !!id && b.dataset.id === id && sel !== id));
  if (!mapReady) return;
  if (!fromMap && id){
    const s = SEDI.find(x => x.id === id);
    if (s) popup.setLngLat([s.lng, s.lat])
                .setHTML('<b>'+esc(s.nome)+'</b><small>'+esc(s.citta)+'</small>').addTo(map);
  } else if (!fromMap && !id) popup.remove();
}

/* ============================================================
   SCHEDA SEDE
   ============================================================ */
function open(id){
  const s = SEDI.find(x => x.id === id);
  if (!s) return;
  sel = id;
  if (mapReady){
    map.setFilter('pt-on', ['==',['get','id'], id]);
    popup.remove();
    // A questo zoom lo stile mostra negozi, parcheggi e fermate intorno alla sede.
    map.flyTo({center:[s.lng, s.lat], zoom:16, duration:800});
  }

  $('#gt-dname').innerHTML = nomeHtml(s);
  $('#gt-daddr').textContent = addr(s) || s.citta || (daAprire(s) && !(s.nota || '').trim() ? RIGA_ATTESA : '');

  const st = s._st;
  const dest = s.lat + ',' + s.lng;

  // Foto della sede. Convenzione: foto/<id>.jpg. Se manca, l'elemento si toglie da
  // solo invece di lasciare l'icona di immagine rotta.
  const hero = s.foto
    ? '<div class="hero"><img src="' + esc(s.foto) + '" alt="' + esc(s.nome) + '" loading="lazy"'
      + ' onerror="this.closest(\'.hero\').remove()"></div>'
    : '';

  const stHtml = daAprire(s)        ? '<div class="st soon" style="margin:0 0 14px"><i></i>' + esc(avviso(s)) + '</div>'
               : st.state === 'open' ? '<div class="st open" style="margin:0 0 14px"><i></i>' + rigaStato(st) + '</div>'
               : st.state === 'shut' ? '<div class="st shut" style="margin:0 0 14px"><i></i>' + rigaStato(st) + '</div>' : '';

  const hoursHtml = st.rows
    ? '<div class="sec"><h4>Orari</h4><dl class="hours">'
      + st.rows.map((r, i) =>
          '<dt' + (i === st.oggi ? ' class="now"' : '') + '>' + esc(r[0]) + '</dt>'
        + '<dd' + (i === st.oggi ? ' class="now"' : '') + '>' + esc(r[1]) + '</dd>').join('')
      + '</dl></div>'
    : '';

  const tags = [isH24(s) && 'H24'].filter(Boolean);
  const featHtml = tags.length
    ? '<div class="sec"><h4>In questa sede</h4><div class="feats">'
      + tags.map(t => '<span class="tag feat">' + t + '</span>').join('') + '</div></div>'
    : '';

  /* Due pulsanti, non tre. "Indicazioni" e "Google Maps" portavano nello stesso
     posto, e il numero scritto sotto ripeteva quello che il pulsante "Chiama"
     gia' faceva: qui il numero E' il pulsante, cosi' da telefono lo chiami e da
     computer lo leggi. */
  const tel = s.telefono ? s.telefono.replace(/\s/g,'') : '';
  const azioni = '<div class="actions">'
    + '<a class="btn solid" target="_blank" rel="noopener"'
    + ' href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '">'
    +   ICONA_ROTTA + 'Indicazioni</a>'
    + (tel ? (() => {
        const n = fmtTel(s.telefono);
        return '<a class="btn" href="tel:' + esc(tel) + '">' + ICONA_TEL
             + (n.pre ? '<span class="pre">' + n.pre + '</span>' : '')
             + '<span class="num">' + esc(n.num) + '</span></a>';
      })() : '')
    + '</div>';

  /* Sotto gli orari restava un buco. Le tre sedi piu' vicine a QUESTA (non a chi
     guarda) sono l'unica cosa utile che i dati sanno gia' dire. */
  const vicine = SEDI.filter(x => x.id !== s.id)
    .map(x => ({sede: x, d: haversine(s.lat, s.lng, x.lat, x.lng)}))
    .sort((a, b) => a.d - b.d).slice(0, 3);
  const vicineHtml = vicine.length
    ? '<div class="sec"><h4>Altre sedi vicine</h4><div class="vicine">'
      + vicine.map(v => '<button class="vic" data-id="' + v.sede.id + '">'
          + '<span>' + nomeHtml(v.sede) + '</span>'
          + '<span class="tag km">' + fmtM(v.d) + '</span></button>').join('')
      + '</div></div>'
    : '';

  $('#gt-dbody').innerHTML = hero + stHtml + azioni + hoursHtml + featHtml + vicineHtml;

  $('#gt-dbody').querySelectorAll('.actions a').forEach(a => {
    a.addEventListener('click', () => segnala(
      a.getAttribute('href').indexOf('tel:') === 0 ? 'chiama' : 'indicazioni',
      {id: s.id, nome: s.nome}));
  });

  $('#gt-dbody').querySelectorAll('.vic').forEach(b => {
    b.onclick = () => { $('#gt-dbody').scrollTop = 0; open(b.dataset.id); };
  });

  $('#gt-detail').classList.add('open');
  $('#gt-detail').setAttribute('aria-hidden','false');
  segnaNellIndirizzo(s.id);
  /* `stato` separa l'interesse per una palestra che c'e' da quello per una che
     deve ancora aprire: il secondo e' una previsione di domanda, e vale piu' del
     primo quando si decide dove aprire. */
  segnala('sede-aperta', {id: s.id, nome: s.nome, citta: s.citta, stato: s.stato || ''});
  render();
}

/* La scheda aperta finisce nell'indirizzo della pagina: cosi' un link porta
   direttamente su quella palestra, e un'inserzione su Carpi puo' aprire il
   locator gia' su Carpi. Si usa replaceState per non riempire la cronologia
   di passi indietro, e si toccano solo i nostri parametri. */
function segnaNellIndirizzo(id){
  try {
    const u = new URL(location.href);
    id ? u.searchParams.set('sede', id) : u.searchParams.delete('sede');
    history.replaceState(null, '', u);
  } catch(e){}
}

/* Un evento per ogni azione che conta, su due canali.

   Il primo e' un evento del browser sull'elemento del locator, per chi vuole
   agganciarsi con tre righe di JavaScript. Il secondo e' il dataLayer, che sul
   sito c'e' gia' (Tag Manager GTM-N9N7C997): li' l'evento diventa visibile a
   GTM e da GTM si manda dove si vuole, senza rimettere le mani qui dentro.
   Se il dataLayer non esiste — anteprime, prove in locale — non succede niente. */
function segnala(nome, dati){
  try {
    (document.querySelector('#gt-locator') || document.body)
      .dispatchEvent(new CustomEvent('gt:' + nome, {detail: dati, bubbles: true}));
  } catch(e){}
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event: 'gt_' + nome.replace(/-/g, '_')}, dati));
  } catch(e){}
}

function close(){
  sel = null;
  segnaNellIndirizzo(null);
  if (mapReady) map.setFilter('pt-on', ['==',['get','id'],' ']);
  $('#gt-detail').classList.remove('open');
  $('#gt-detail').setAttribute('aria-hidden','true');
  render();
  fit(visible());
}

/* ============================================================
   EVENTI
   ============================================================ */
$('#gt-back').onclick = close;

/* Schermo intero.
   Non usiamo maplibregl.FullscreenControl: su iOS Safari l'API Fullscreen non vale
   per gli elementi normali, `document.fullscreenEnabled` è false e il controllo
   semplicemente non compare. Quindi API nativa dove c'è, ripiego CSS dove manca. */
/* A schermo intero ci va la scena intera, non la sola mappa: l'elenco resta
   visibile appoggiato sopra, che e' il motivo per cui uno apre un locator. */
const scena = $('#gt-scena');
const canNativeFS = () => !!(document.fullscreenEnabled || document.webkitFullscreenEnabled);
const inFS = () => scena.classList.contains('fs');

function cssFS(on){
  scena.classList.toggle('fs', on);
  document.body.classList.toggle('fs-lock', on);
  // Fuori da schermo intero la mappa e' un riquadro dentro la pagina e serve il
  // gesto a due dita per non rubare lo scorrimento; a schermo intero la pagina
  // non c'e' piu' e chiedere due dita e' solo un fastidio.
  try { map && map.cooperativeGestures && map.cooperativeGestures[on ? 'disable' : 'enable'](); } catch(e){}
  if (on) foglio(1);              // il foglio riparte da meta' altezza
  setTimeout(() => map && map.resize(), 60);
}

function toggleFS(){
  if (inFS()){
    if (document.fullscreenElement){
      (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    }
    cssFS(false);
    return;
  }
  cssFS(true);
  if (!canNativeFS()) return;
  const req = scena.requestFullscreen || scena.webkitRequestFullscreen;
  Promise.resolve(req.call(scena)).catch(() => {});
}

// Esc chiude anche quando lo schermo intero e' solo nostro (iOS, iframe senza permesso).
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && inFS() && !document.fullscreenElement) cssFS(false);
});

/* Il foglio dell'elenco su telefono: tre altezze, come le mappe delle app.
   Si trascina con la maniglia, e dove lo lasci scatta all'altezza piu' vicina. */
/* Tre altezze. Il massimo non arriva a schermo pieno: sopra al foglio devono
   restare visibili il pulsante di uscita e quello della posizione. */
const ALTEZZE = [0.24, 0.55, 0.85];
let scatto = 1;

function foglio(i){
  scatto = Math.max(0, Math.min(ALTEZZE.length - 1, i));
  $('#gt-scena').querySelector('.panel').style.setProperty('--gt-foglio', Math.round(ALTEZZE[scatto] * 100) + 'dvh');
}

(function trascinaFoglio(){
  const man = $('#gt-maniglia');
  const pan = scena.querySelector('.panel');
  let y0 = 0, h0 = 0, hCorr = 0, mosso = false;

  man.addEventListener('pointerdown', e => {
    if (!inFS()) return;
    y0 = e.clientY; h0 = hCorr = pan.getBoundingClientRect().height; mosso = false;
    scena.classList.add('trascino');
    try { man.setPointerCapture(e.pointerId); } catch(err){}
  });

  man.addEventListener('pointermove', e => {
    if (!scena.classList.contains('trascino')) return;
    const dy = y0 - e.clientY;
    if (Math.abs(dy) > 3) mosso = true;
    hCorr = Math.max(90, Math.min(innerHeight * 0.85, h0 + dy));
    pan.style.setProperty('--gt-foglio', hCorr + 'px');
  });

  const fine = () => {
    if (!scena.classList.contains('trascino')) return;
    scena.classList.remove('trascino');
    if (!mosso){ foglio(scatto >= ALTEZZE.length - 1 ? 0 : scatto + 1); return; }
    /* L'altezza va letta dalla variabile, non dall'elemento: togliendo la classe
       si riaccende la transizione e la misura tornerebbe quella di partenza,
       facendo scattare il foglio indietro invece che avanti. */
    const q = hCorr / innerHeight;
    let vicino = 0;
    ALTEZZE.forEach((a, i) => { if (Math.abs(a - q) < Math.abs(ALTEZZE[vicino] - q)) vicino = i; });
    foglio(vicino);
  };
  man.addEventListener('pointerup', fine);
  man.addEventListener('pointercancel', fine);
})();
/* Controllo MapLibre: si aggancia al gruppo dei pulsanti mappa, quindi eredita
   posizione, dimensioni e stile degli altri e non puo' disallinearsi. */
/* "Dove sono": stesso gesto del pulsante nella barra di ricerca, ma raggiungibile
   mentre si sta guardando la mappa, senza tornare all'elenco. */
class PosizioneGT {
  onAdd(){
    this._c = document.createElement('div');
    this._c.className = 'maplibregl-ctrl maplibregl-ctrl-group gt-fs';
    const b = document.createElement('button');
    b.type = 'button';
    b.title = 'La mia posizione';
    b.setAttribute('aria-label', 'La mia posizione');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><circle cx="12" cy="12" r="8"/><path d="M12 1.5v3M12 19.5v3M1.5 12h3M19.5 12h3"/></svg>';
    b.onclick = () => { ME ? mostraMe() : $('#gt-geo').click(); };
    this._c.appendChild(b);
    return this._c;
  }
  onRemove(){ this._c.remove(); }
}

class FullscreenGT {
  onAdd(){
    this._c = document.createElement('div');
    this._c.className = 'maplibregl-ctrl maplibregl-ctrl-group gt-fs gt-esci';
    const b = document.createElement('button');
    b.type = 'button';
    b.title = 'Schermo intero';
    b.setAttribute('aria-label', 'Schermo intero');
    b.innerHTML =
      '<svg class="o" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>'
    + '<svg class="x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    b.onclick = toggleFS;
    this._c.appendChild(b);
    return this._c;
  }
  onRemove(){ this._c.remove(); }
}

document.addEventListener('fullscreenchange', () => {
  if (!document.fullscreenElement && inFS()) cssFS(false);
  setTimeout(() => map && map.resize(), 60);
});

document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (inCssFS()) cssFS(false);     // Esc nativo lo gestisce il browser, questo è il ripiego
  else if (sel) close();
});

let qTimer = null, qTimerSeg = null, qDetta = null;

/* La segnalazione ha un tempo suo, piu' lungo dell'inquadratura. Con un timer
   solo da 400 ms una ricerca ne mandava tre — "car", "carp", "carpi" — e in GA4
   contavano come tre ricerche, con due testi che nessuno ha mai cercato finiti
   fra i piu' cercati. Visto sul sito vero il 12 settembre 2026.
   400 ms bastano alla mappa per seguire chi scrive; per capire se ha finito no. */
function riportaRicerca(){
  clearTimeout(qTimerSeg);
  const testo = query.trim();
  if (testo.length < 2 || testo === qDetta) return;
  qDetta = testo;
  const trovate = visible();
  /* La prima della lista e' la sede che quella ricerca ha "prodotto": e' la
     colonna che su Stockist si chiama closest store, ed e' quella che dice
     quale bacino ha domanda. */
  segnala('ricerca', {testo, risultati: trovate.length,
                      prima_sede: trovate.length ? trovate[0].nome : ''});
}

$('#gt-q').oninput = e => {
  query = e.target.value;
  $('#gt-qclear').style.display = query ? 'block' : 'none';
  render();
  clearTimeout(qTimer);
  qTimer = setTimeout(() => { if (!sel) fit(visible()); }, 400);
  clearTimeout(qTimerSeg);
  qTimerSeg = setTimeout(riportaRicerca, 900);
};

/* Chi trova subito e clicca il risultato lascia il campo prima dei 900 ms: senza
   questo, le ricerche andate a segno sarebbero proprio quelle che non si contano. */
$('#gt-q').onblur = riportaRicerca;

$('#gt-qclear').onclick = () => {
  query = ''; $('#gt-q').value = ''; $('#gt-qclear').style.display = 'none';
  clearTimeout(qTimerSeg); qDetta = null;
  render(); fit(visible());
};

/* Il menu delle regioni si rimisura quando Inter e' arrivato: con il ripiego di
   sistema la larghezza sarebbe sbagliata di qualche pixel. */
if (document.fonts && document.fonts.ready){
  document.fonts.ready.then(() => adattaSelect($('#gt-reg')));
}

/* Sposta l'interruttore senza far partire niente: serve anche quando e' il
   codice a cambiare idea, per esempio se la geolocalizzazione fallisce. */
function segnaOrdine(v){
  sortBy = v;
  $('#gt-sort').querySelectorAll('.seg').forEach(b => {
    b.setAttribute('aria-pressed', String(b.dataset.v === v));
  });
}

$('#gt-sort').querySelectorAll('.seg').forEach(b => {
  b.onclick = () => {
    if (b.dataset.v === sortBy) return;
    segnaOrdine(b.dataset.v);
    // "Vicine" senza posizione non vuol dire niente: prima si chiede dove sei.
    if (sortBy === 'distance' && !ME) $('#gt-geo').click();
    else render();
  };
});

/* Porta la mappa sulla posizione dell'utente.

   Prima si faceva un fitBounds su "io + le tre palestre piu' vicine": se quelle
   erano a decine di chilometri il riquadro diventava enorme e la posizione finiva
   a fare da puntino in un angolo, con l'effetto di non essere stati portati da
   nessuna parte. Ora il centro e' la posizione, e la palestra piu' vicina entra
   nell'inquadratura solo se e' abbastanza vicina da starci.

   Lo zoom tiene conto di `accuracy`: da computer la posizione arriva dalla rete e
   puo' sbagliare di chilometri, e stringere a zoom 15 su un dato cosi' impreciso
   racconta una precisione che non c'e'. */
/* Un cerchio di raggio in metri, in coordinate. Un grado di latitudine vale
   111.320 metri ovunque; uno di longitudine si accorcia salendo verso il polo,
   quindi va diviso per il coseno della latitudine, altrimenti in Italia il
   cerchio verrebbe schiacciato di un terzo. */
function cerchio(lat, lng, metri, punti = 64){
  const dLat = metri / 111320;
  const dLng = metri / (111320 * Math.cos(lat * Math.PI / 180));
  const anello = [];
  for (let i = 0; i <= punti; i++){
    const a = i / punti * 2 * Math.PI;
    anello.push([lng + dLng * Math.cos(a), lat + dLat * Math.sin(a)]);
  }
  return {type:'Feature', geometry:{type:'Polygon', coordinates:[anello]}, properties:{}};
}

function mostraMe(){
  if (!ME || !map) return;            // mappa non ancora creata: ci pensa map.on('load')

  /* Sotto i 25 metri l'alone sarebbe piu' piccolo del pallino; sopra i 5 km
     coprirebbe mezza regione senza aggiungere niente. */
  const sorgente = map.getSource && map.getSource('mia');
  if (sorgente){
    const p = ME.prec || 0;
    sorgente.setData(p >= 25 && p <= 5000
      ? {type:'FeatureCollection', features:[cerchio(ME.lat, ME.lng, p)]}
      : {type:'FeatureCollection', features:[]});
  }

  meMarker && meMarker.remove();
  const el = document.createElement('div');
  el.className = 'me-pin';
  el.title = ME.prec ? 'La tua posizione, approssimata a circa ' + Math.round(ME.prec) + ' m' : 'La tua posizione';
  meMarker = new maplibregl.Marker({element:el}).setLngLat([ME.lng, ME.lat]).addTo(map);

  const prec = ME.prec || 0;
  const zoomPrecisione = prec > 5000 ? 10 : prec > 1500 ? 11 : prec > 500 ? 12 : 13.5;

  const vicine = visible();
  const piuVicina = vicine.length ? vicine[0] : null;

  // Sotto i 20 km ci stanno entrambe nello schermo; oltre, si perderebbe il dettaglio
  // intorno alla posizione per mostrare una palestra che comunque e' lontana.
  if (piuVicina && piuVicina.d != null && piuVicina.d < 20000){
    const b = new maplibregl.LngLatBounds();
    b.extend([ME.lng, ME.lat]);
    b.extend([piuVicina.lng, piuVicina.lat]);
    map.fitBounds(b, {padding:{top:70, bottom:70, left:70, right:70}, maxZoom: zoomPrecisione, duration:700});
  } else {
    map.flyTo({center:[ME.lng, ME.lat], zoom: zoomPrecisione, duration:700});
  }
}

/* Scrive il messaggio senza toccare l'icona: con textContent l'SVG dentro il
   pulsante veniva cancellato al primo clic e non tornava più. */
function testoGeo(b, msg){
  const p = $('#gt-esito-geo');
  if (p) p.textContent = msg || '';
}

$('#gt-geo').onclick = () => {
  const b = $('#gt-geo');
  if (!navigator.geolocation){ testoGeo(b, 'Geolocalizzazione non disponibile'); b.disabled = true; return; }
  b.disabled = true;
  navigator.geolocation.getCurrentPosition(pos => {
    ME = {lat:pos.coords.latitude, lng:pos.coords.longitude, prec:pos.coords.accuracy};
    segnaOrdine('distance');
    filterReg = null; buildChips(); render();
    mostraMe();

    /* Chi si e' fatto localizzare, e quale sede gli e' capitata piu' vicina. Non
       mandiamo le coordinate: la citta' la sa gia' GA4 dal suo indirizzo, e
       spedire la posizione esatta sarebbe un dato personale in piu' senza
       bisogno. La distanza si arrotonda al chilometro. */
    const vicine = visible();
    if (vicine.length && vicine[0].d != null)
      segnala('posizione', {sede_piu_vicina: vicine[0].nome,
                            distanza_km: Math.round(vicine[0].d / 1000)});
  }, err => {
    // L'app precedente non gestiva il rifiuto: il pulsante restava muto.
    b.disabled = false;
    testoGeo(b, err.code === 1 ? 'Permesso negato' : 'Posizione non disponibile');
    segnala('posizione-negata', {motivo: err.code === 1 ? 'permesso negato' : 'non disponibile'});
    setTimeout(() => { testoGeo(b, ''); }, 3000);
    if (sortBy === 'distance'){ segnaOrdine('name'); render(); }
  }, {enableHighAccuracy:true, timeout:10000, maximumAge:60000});
};

/* ============================================================
   AVVIO
   I dati e la lista partono subito. MapLibre (~250 KB) si scarica solo quando
   la mappa sta per entrare nello schermo: se il locator e' a meta' di una pagina
   lunga, chi non ci arriva non lo scarica mai.
   ============================================================ */
// Solo il JS (220 KB) e' pigro. Il CSS (8 KB) sta nel documento: caricato dopo,
// i default di MapLibre sovrascriverebbero i nostri stili scuri.
let caricamento = null;
function loadMapLibre(){
  if (caricamento) return caricamento;
  // Il foglio di stile e pmtiles prima, poi la mappa: MapLibre all'avvio legge le
  // misure del contenitore, e senza il suo CSS le trova sbagliate.
  return caricamento = Promise.all([
    risorsa('css', CDN.maplibreCss[0], CDN.maplibreCss[1]),
    risorsa('js',  CDN.pmtiles[0],     CDN.pmtiles[1]),
  ]).then(() => risorsa('js', CDN.maplibreJs[0], CDN.maplibreJs[1]));
}

function avviaMappa(){
  loadMapLibre().then(initMap).catch(err => {
    console.error(err);
    const l = $('#gt-loading');
    if (l) l.innerHTML = 'Mappa non disponibile.<br><small>La lista delle palestre funziona lo stesso.</small>';
  });
}

boot();

/* Quante persone la mappa la VEDONO davvero.

   Il locator sta in fondo alla pagina: contare i caricamenti direbbe quante volte
   la pagina si e' aperta, non quante volte qualcuno e' arrivato fin qui. Questo
   scatta una volta sola, quando meta' del blocco e' entrata nello schermo ed e'
   rimasta li' un secondo — il tempo di guardarla, non di attraversarla scorrendo.
   E' il denominatore vero: quanti la vedono, quanti poi fanno qualcosa. */
if ('IntersectionObserver' in window){
  let visto = false, attesaVisto = null;
  const guarda = new IntersectionObserver(entries => {
    const dentro = entries.some(e => e.isIntersecting);
    if (visto) return;
    if (!dentro){ clearTimeout(attesaVisto); attesaVisto = null; return; }
    if (attesaVisto) return;
    attesaVisto = setTimeout(() => {
      visto = true;
      guarda.disconnect();
      segnala('visto', {palestre: SEDI.length});
    }, 1000);
  }, {threshold: 0.5});
  guarda.observe($('#gt-scena'));
}

if ('IntersectionObserver' in window){
  const io = new IntersectionObserver(entries => {
    if (!entries.some(e => e.isIntersecting)) return;
    io.disconnect();
    avviaMappa();
  }, {rootMargin: '300px'});
  io.observe($('#gt-mapwrap'));

  /* Rete di sicurezza, ma mirata. In alcuni contesti l'osservatore non scatta mai:
     iframe di dimensione zero, anteprime che riportano un viewport 0x0. Li' la mappa
     va avviata lo stesso, o la pagina resta per sempre su "Carico la mappa…".

     Prima qui c'era un `setTimeout` che partiva sempre dopo quattro secondi. Sulla
     home il locator sta in fondo a diecimila pixel di pagina: voleva dire aprire la
     mappa a ogni visita, anche a chi fin li' non arrivava mai. Ogni apertura costa
     sei richieste al Worker delle tessere, e il Worker ha un tetto giornaliero.
     Adesso il ripiego scatta solo dove l'osservatore non puo' funzionare. */
  setTimeout(() => {
    if (caricamento) return;
    const r = $('#gt-mapwrap').getBoundingClientRect();
    const schermo = window.innerHeight || 0;
    const degenere = schermo === 0 || (r.width === 0 && r.height === 0);
    if (!degenere) return;              // viewport sano: se ne occupa l'osservatore
    io.disconnect();
    avviaMappa();
  }, 4000);
} else {
  avviaMappa();
}


/* Unica cosa che esce dalla IIFE: serve a PageFly e al tema per rilanciare il
   locator se la sezione viene reinserita nel DOM senza ricaricare la pagina. */
window.GTLocator = {avvia: avviaMappa, sedi: () => SEDI};

}

/* Avvia ogni contenitore trovato, una volta sola. PageFly e il theme editor
   inseriscono i blocchi dopo il caricamento: `avvia` si puo' richiamare a mano. */
function avvia(){
  stile();
  document.querySelectorAll('#gt-locator, .gt-locator').forEach(el => {
    if (el.dataset.gtPronto) return;
    el.dataset.gtPronto = '1';
    el.innerHTML = HTML;
    try { avviaSu(el); } catch (e) { console.error('locator:', e); }
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
else avvia();

// Il theme editor di Shopify reinserisce la sezione a ogni modifica.
document.addEventListener('shopify:section:load', avvia);

window.GTLocator = {avvia};
})();